import { z } from 'zod';

export const getVideoSchema = z.object({
  video_id: z.string().min(1),
});

export type GetVideoPayload = z.infer<typeof getVideoSchema>;
